export const platforms = {
  'yuanxi': {
    logo: require('@/assets/images/yuanxi/yuanxi-logo.png'),
    url: 'https://yuanxi.online',
    title: '元习 - 新一代数字教材平台',
    cover: require('@/assets/images/yuanxi/cover.jpg'),
    coverTitle: "仰望星空，用好奇心认知世界 —— 元习",
  },
  'zju': {
    logo: require('@/assets/images/yuanxi/zju-logo.png'),
    url: 'http://etextbook.lifangshu.com',
    title: '浙江大学出版社',
    cover: require('@/assets/images/yuanxi/cover.jpg'),
  },
  'sciencep': {
    logo: require('@/assets/images/yuanxi/sciencep/logo.png'),
    url: 'https://edu.cspmmed.com/',
    title: '科学出版社',
    cover: require('@/assets/images/yuanxi/sciencep/cover.jpg'),
    icon: require('@/assets/images/yuanxi/sciencep/icon.png'),
  },
  'csspw': {
    logo: require('@/assets/images/yuanxi/csspw-logo.png'),
    url: 'https://yuanxi.online',
    title: '中国社会科学出版社',
    cover: require('@/assets/images/yuanxi/cover.jpg'),
  },
  'xjtupress': {
    logo: require('@/assets/images/yuanxi/xjtupress/logo.png'),
    icon: require('@/assets/images/yuanxi/xjtupress/icon.png'),
    url: 'https://ebook.xjtupress.com',
    title: '西安交通大学出版社',
    cover: require('@/assets/images/yuanxi/xjtupress/cover.jpg'),
  },
  'hnfnu': {
    logo: require('@/assets/images/yuanxi/hnfnu-logo.png'),
    url: 'https://hnfnu.lessonplan.cn',
    title: '湖南第一师范学院',
    cover: require('@/assets/images/yuanxi/cover.jpg'),
  },
  'nwu': {
    logo: require('@/assets/images/yuanxi/nwu-logo.png'),
    url: 'https://nwu.lessonplan.cn',
    title: '西北大学出版社',
    cover: require('@/assets/images/yuanxi/cover.jpg'),
  },
  'uestcp': {
    logo: require('@/assets/images/yuanxi/uestcp-logo.png'),
    url: 'https://nwu.lessonplan.cn',
    title: '电子科技大学出版社',
    cover: require('@/assets/images/yuanxi/cover.jpg'),
  },
  'airport': {
    logo: require('@/assets/images/inner_training/icon.png'),
    url: 'https://yuanxi.online',
    title: '舟道教育',
    cover: require('@/assets/images/airport/cover.jpg'),
  },
  'xnjdcbs': {
    logo: require('@/assets/images/yuanxi/xnjdcbs-logo.png'),
    url: 'https://ebook.xnjdcbs.com',
    title: '西南交通大学出版社',
    cover: require('@/assets/images/yuanxi/cover.jpg'),
  },
  'bsu': {
    logo: require('@/assets/images/yuanxi/bsu-logo.png'),
    url: 'https://bsustore.lessonplan.cn',
    title: '北京体育大学出版社',
    cover: require('@/assets/images/yuanxi/cover.jpg'),
  },
  'hust': {
    logo: require('@/assets/images/yuanxi/hust-logo.png'),
    url: 'https://huststore.lessonplan.cn',
    title: '华中科技大学出版社',
    cover: require('@/assets/images/yuanxi/cover.jpg'),
  },
}